import { useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";

export const TOP_AD_SRC =
  "//relieved-understanding.com/baXAVssId.GslR0tY/WecR/Recmn9pu/ZSUSljkGPsTbcbz/NXTpc_0WNszkM/tbN/z/MM1oNIz/Q/3/Ncwj";

export default function CdrTopAd() {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return undefined;

    const script = document.createElement("script");
    script.settings = {};
    script.src = TOP_AD_SRC;
    script.async = true;
    script.referrerPolicy = "no-referrer-when-downgrade";
    container.appendChild(script);

    return () => script.remove();
  }, []);

  return (
    <Box
      data-testid="cdr-top-ad"
      aria-label="Top advertisement"
      sx={{ width: "100%", overflow: "hidden", my: { xs: 1, sm: 1.5 }, textAlign: "center" }}
    >
      <Typography variant="caption" color="text.secondary">Advertisement</Typography>
      <Box ref={containerRef} sx={{ width: "100%", minHeight: { xs: 90, sm: 110 }, maxWidth: 970, mx: "auto" }} />
    </Box>
  );
}
